import { SidePanelPropertyDescriptor } from 'src/graphql/entities/side-panel-personalization';

export interface SidePanelRenderableRow {
  descriptor: SidePanelPropertyDescriptor;
  visible: boolean;
}

/** descriptor of a row the panel renders itself (Row-less fields belong to cards) */
export type RenderableSidePanelRow = SidePanelPropertyDescriptor &
  Required<Pick<SidePanelPropertyDescriptor, 'Row'>>;

export interface SidePanelRowCluster {
  group: { key: string; label: string } | null;
  rows: RenderableSidePanelRow[];
}

export function getDisplayedRowClusters(
  properties: SidePanelRenderableRow[],
  hideEmpty: boolean,
): SidePanelRowCluster[] {
  const clusters: SidePanelRowCluster[] = [];

  for (const { descriptor, visible } of properties) {
    if (!descriptor.Row || !visible || (hideEmpty && descriptor.isEmpty)) {
      continue;
    }

    const row = descriptor as RenderableSidePanelRow;
    const group = descriptor.group ?? null;
    const current = clusters[clusters.length - 1];

    if (current && (current.group?.key ?? null) === (group?.key ?? null)) {
      current.rows.push(row);
    } else {
      clusters.push({ group, rows: [row] });
    }
  }

  return clusters;
}
